import { useContext } from 'react';
import { SiteContext, RuntimeConfigurationContext } from 'libs/contexts';
export default function useToLogin() {
  const site = useContext(SiteContext);
  const runtimeConfig = useContext(RuntimeConfigurationContext);
  // 登录跳转
  const handleLogin = () => {
    if (site?.hasEgo) {
      const fgfHost = runtimeConfig.find((item) => item.key === 'fgfHostHttpUrl')?.value ?? '';
      location.href = `${fgfHost}/sso/xlogin?return_url=${encodeURIComponent(location.href)}`;
    } else {
      location.href = `/sso/xlogin?return_url=${encodeURIComponent(location.href)}`;
    }
  };
  return {
    handleLogin,
  };
}
